import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, TrendingDownIcon, AlertTriangleIcon, ThumbsUpIcon } from 'lucide-react';
interface InsightCard {
  title: string;
  value: string;
  type: 'neutral' | 'positive' | 'warning';
  icon: React.ElementType;
  targetId?: string;
}
interface AIResponseProps {
  message: string;
  insights?: InsightCard[];
  onInsightClick?: (id: string) => void;
}
export function AIResponse({
  message,
  insights,
  onInsightClick
}: AIResponseProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex gap-4 mb-8" data-id="element-46">
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-primary-indigo to-ai-purple flex items-center justify-center shadow-md" data-id="element-47">
        <SparklesIcon className="w-5 h-5 text-white" data-id="element-48" />
      </div>

      <div className="flex-1 min-w-0 space-y-4" data-id="element-49">
        <div className="bg-white rounded-2xl rounded-tl-none p-4 shadow-soft border border-slate-100" data-id="element-50">
          <p className="text-slate-700 text-[15px] leading-relaxed" data-id="element-51">
            {message}
          </p>
        </div>

        {insights && insights.length > 0 && <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-52">
            {insights.map((insight, idx) => {
          const Icon = insight.icon;
          const colorClasses = {
            neutral: 'bg-slate-50 border-slate-200 text-slate-700',
            positive: 'bg-success/5 border-success/20 text-success',
            warning: 'bg-warning/5 border-warning/20 text-warning'
          };
          const clickable = Boolean(insight.targetId && onInsightClick);
          return <motion.button key={idx} type="button" disabled={!clickable} onClick={() => clickable && onInsightClick!(insight.targetId!)} initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2 + idx * 0.1
          }} className={`p-3 rounded-xl border text-left ${colorClasses[insight.type]} flex flex-col gap-1.5 transition-all ${clickable ? 'cursor-pointer hover:shadow-md hover:-translate-y-0.5' : 'cursor-default'}`} data-id="element-53">
                  <div className="flex items-center gap-1.5 text-[13px] font-medium opacity-80" data-id="element-54">
                    <Icon className="w-3.5 h-3.5" data-id="element-55" />
                    {insight.title}
                  </div>
                  <div className="font-display font-bold text-base" data-id="element-56">
                    {insight.value}
                  </div>
                  {clickable && <span className="text-[11px] font-medium opacity-70 mt-auto" data-id="element-57">
                      Tap to view →
                    </span>}
                </motion.button>;
        })}
          </div>}
      </div>
    </motion.div>;
}